import { FORM_PATHS, openInModalOrPage } from '../../modals';

export const CREATE_MEETING_TYPE_COMPLETE = 'CompleteMeeting';

export const completeMeeting = meeting => (dispatch, getState) => {
    dispatch(openInModalOrPage(FORM_PATHS.CompleteMeetingModal, meeting.meetingId, meeting, meeting.startDate));
};
